"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CalendarWeek = CalendarWeek;
exports.enhance = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _add_days = _interopRequireDefault(require("date-fns/add_days"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _is_after = _interopRequireDefault(require("date-fns/is_after"));

var _is_same_day = _interopRequireDefault(require("date-fns/is_same_day"));

var _is_same_month = _interopRequireDefault(require("date-fns/is_same_month"));

var _range = _interopRequireDefault(require("lodash/range"));

var _find = _interopRequireDefault(require("lodash/find"));

var _withProps = _interopRequireDefault(require("recompose/withProps"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _defaultProps = _interopRequireDefault(require("recompose/defaultProps"));

var _CalendarDay = _interopRequireDefault(require("./CalendarDay"));

function isClosed(date, closures) {
  return !!(0, _find["default"])(closures, function (closure) {
    return (0, _is_same_day["default"])(date, closure);
  });
}

var enhance = (0, _compose["default"])((0, _defaultProps["default"])({
  today: new Date()
}), (0, _withProps["default"])(function (props) {
  return {
    days: (0, _range["default"])(0, 7).map(function (i) {
      var date = (0, _add_days["default"])(props.start, i);
      var closed = isClosed(date, props.closures);
      var past = !(0, _is_same_day["default"])(date, props.today) && (0, _is_after["default"])(props.today, date);
      var valid = !props.resWindow || !closed && !past && (0, _is_after["default"])(props.resWindow, date);
      var today = (0, _is_same_day["default"])(date, props.today);
      var selected = (0, _is_same_day["default"])(date, props.selectedDate);
      return {
        date: date,
        closed: !props.allValid && !past && closed,
        today: today,
        past: past,
        open: !!props.allValid || today && valid || !closed && !past && valid,
        invalid: !valid,
        notInCurrentMonth: !(0, _is_same_month["default"])(props.currentMonth, date),
        selected: selected
      };
    })
  };
}));
exports.enhance = enhance;

function CalendarWeek(_ref) {
  var days = _ref.days,
      onDateClick = _ref.onDateClick;
  return /*#__PURE__*/_react["default"].createElement("tr", {
    className: "calendar-week"
  }, days.map(function (day) {
    return /*#__PURE__*/_react["default"].createElement(_CalendarDay["default"], (0, _extends2["default"])({
      key: (0, _format["default"])(day.date, 'YYMD'),
      onDateClick: onDateClick
    }, day));
  }));
}

CalendarWeek.propTypes = {
  onDateClick: _propTypes["default"].func,
  days: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    date: _propTypes["default"].instanceOf(Date).isRequired,
    closed: _propTypes["default"].bool.isRequired,
    today: _propTypes["default"].bool.isRequired,
    open: _propTypes["default"].bool.isRequired,
    invalid: _propTypes["default"].bool.isRequired,
    notInCurrentMonth: _propTypes["default"].bool.isRequired
  }))
};
CalendarWeek.defaultProps = {
  days: []
};

var _default = enhance(CalendarWeek);

exports["default"] = _default;